import { BrowserRouter, Route, Routes } from "react-router-dom";
// Core pages
import HomePage from "./pages/HomePage";
import ConversationPageLayer from "./pages/ConversationsPage";

// Users
import AddUserPage from "./pages/AddUserPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewProfilePage from "./pages/ViewProfilePage";

//Organisation
import AddOrganisationPage from "./pages/AddOrganisationPage";
import OrganisationListPage from "./pages/OrganisationListPage";
import OrganisationViewPage from "./components/OrganisationViewPage";

// Role & Access
import RoleAccessPage from "./pages/RoleAccessPage";
import AssignRolePage from "./pages/AssignRolePage";

// Settings
import CompanyPage from "./pages/CompanyPage";
import NotificationPage from "./pages/NotificationPage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import ThemePage from "./pages/ThemePage";
import CurrenciesPage from "./pages/CurrenciesPage";
import LanguagePage from "./pages/LanguagePage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";

// Auth
import SignInPage from "./pages/SignInPage";
// import SignUpPage from "./pages/SignUpPage";
// import ForgotPasswordPage from "./pages/ForgotPasswordPage";

// Fallback
import ErrorPage from "./pages/ErrorPage";
import Leads from "./pages/Leads";
import RouteScrollToTop from "react-scroll-to-top";
import { ProtectedLayout } from "./utils/ProtectedLayout";

// Api-key page
import ApiKeyPage from './pages/ApiKeyPage';
import EditOrganisationPage from "./pages/EditOrganisationPage";
import ViewAllUserPage from "./pages/ViewAllUserPage";
import { Toaster } from "sonner";
import AddIntegrationPage from "./pages/AddIntegrationPage";
import { ViewAllIntegrationPage } from "./pages/ViewAllIntegrationPage";
import { EditIntegrationWithIdPage } from "./pages/EditIntegrationWithIdPage";
import GenerateWidgetPageLayer from "./pages/GenerateWidgetPage";
import AgentSetup from "./components/AgentLayer";
import AgentPage from "./pages/AgentPage";
import CallLogsPage from "./pages/CallLogsPage";
import PhoneNumberPages from "./pages/PhoneNumberPages";
import SignUpPage from "./pages/SignUpPage";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchCurrentUser } from "./store/app/userSlice";
import { useSelector } from "react-redux";
import { fetchOrgDataWithId } from "./store/app/organizationSlice";
import { fetchAssistants } from "./store/app/assistantSlice";
import PromoCodePage from "./pages/PromoCodePage";
import PricingTierPage from "./pages/PricingTierPage";
import PaymentUrlPage from "./pages/PaymentUrlPage";
import ChatLogsPage from "./pages/ChatLogsPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import WhatsappSettingsPage from "./pages/WhatsappSettingsPage";
import CampaignPage from "./pages/CampaignPage";

function App() {
  const dispatch = useDispatch();
  const userOrgId = useSelector((state) => state?.user?.user?.organizationId);

  // First effect: Fetch user if token is present
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  // Second effect: Wait for userOrgId to be available before dispatching fetchOrgDataWithId
  useEffect(() => {
    if (userOrgId) {
      dispatch(fetchOrgDataWithId(userOrgId));
    }
  }, [userOrgId, dispatch]);
  // console.log("User data:", user);

  useEffect(() => {
    if (userOrgId) {
      dispatch(fetchAssistants(userOrgId));
    }

  }, [dispatch, userOrgId]);
  return (

    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <RouteScrollToTop />
      <Routes>
        <Route element={<ProtectedLayout />}>
          <Route exact path='/' element={<HomePage />} />

          {/* <Route exact path='/leads' element={<Leads />} /> */}

          {/* Organisation */}
          <Route exact path="/all-organisations" element={<OrganisationListPage />} />
          <Route exact path='/add-organisation' element={<AddOrganisationPage />} />
          <Route path="/organisation/view/:id" element={<OrganisationViewPage />} />
          <Route path="/organisation/edit/:id" element={<EditOrganisationPage />} />

          {/* Users */}
          <Route exact path='/add-user' element={<AddUserPage />} />
          <Route exact path='/all-users' element={<ViewAllUserPage />} />

          {/* Add Integration*/}
          <Route exact path='/add-integration' element={<AddIntegrationPage />} />
          <Route exact path='/all-integrations' element={<ViewAllIntegrationPage />} />
          <Route exact path='/api-keys' element={<ApiKeyPage />} />
          <Route path='/integration/edit/:id' element={<EditIntegrationWithIdPage />} />



          {/* Users deafault */}

          <Route exact path='/users-grid' element={<UsersGridPage />} />
          <Route exact path='/users-list' element={<UsersListPage />} />
          <Route exact path='/view-profile' element={<ViewProfilePage />} />

          {/* Role & Access */}
          <Route exact path='/role-access' element={<RoleAccessPage />} />
          <Route exact path='/assign-role' element={<AssignRolePage />} />

          {/* Settings */}
          <Route exact path='/company' element={<CompanyPage />} />
          <Route exact path='/notification' element={<NotificationPage />} />
          <Route exact path='/notification-alert' element={<NotificationAlertPage />} />
          <Route exact path='/theme' element={<ThemePage />} />
          <Route exact path='/currencies' element={<CurrenciesPage />} />
          <Route exact path='/language' element={<LanguagePage />} />
          <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />

          {/* Agent Page */}
          <Route exact path='/assistant' element={<AgentPage />} />
          <Route exact path="/assistant/:id" element={<AgentPage />} />

          {/* Assistants */}
          <Route exact path='/converations' element={<ConversationPageLayer />} />
          <Route exact path='/converations/:assistantId' element={<ConversationPageLayer />} />
          <Route exact path='/generate-widget' element={<GenerateWidgetPageLayer />} />
          <Route exact path='/call-logs' element={<CallLogsPage />} />
          <Route exact path="/chat-logs" element={<ChatLogsPage />} />
          <Route exact path="/phone-number" element={<PhoneNumberPages />} />
          <Route exact path="/campaigns" element={<CampaignPage />} />
          {/* PromoCode & Pricing */}
          <Route exact path="/promo-codes" element={<PromoCodePage />} />
          <Route exact path="/pricing-tiers" element={<PricingTierPage />} />
          <Route exact path="/payment-url" element={<PaymentUrlPage />} />

          <Route exact path="/knowledge-base" element={<KnowledgeBasePage />} />

            {/* Whatsapp */}
        <Route exact path="/whatsapp-settings" element={<WhatsappSettingsPage/>}/>

        </Route>
        {/* Authentication */}
        <Route exact path='/sign-in' element={<SignInPage />} />
        {/* <Route exact path="/sign-up" element={<SignUpPage/>}/> */}
        {/* <Route exact path='/sign-up' element={<SignUpPage />} /> */}
        {/* <Route exact path='/forgot-password' element={<ForgotPasswordPage />} /> */}

        {/* 404 fallback */}
        <Route path='*' element={<ErrorPage />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;
